var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
// '#components' is imported by direct path: its barrel would close the hooks <-> components cycle (see CLAUDE.md).
import { useCallback } from 'react';
import { useModal } from '@lucidlink/uicore';
import { DeclineInvitationModal } from '#components/modals/DeclineInvitationModal';
import { MODAL_IDS } from '#constants';
export const useDeclineInvitationFlow = ({ workspaceId, workspaceName, }) => {
    _react_refresh_temp_1();
    const { closeModal, openModal } = useModal({
        modalId: MODAL_IDS.DeclineInvitation,
    });
    const initDeclineInvitationFlow = useCallback(() => {
        openModal({
            content: (_jsx(DeclineInvitationModal, { closeModal: closeModal, workspaceId: workspaceId, workspaceName: workspaceName })),
        });
    }, [closeModal, openModal, workspaceId, workspaceName]);
    return initDeclineInvitationFlow;
};
_react_refresh_temp_1(useDeclineInvitationFlow, "YKC/OORPLm0zdvxzzYDikfek9NY=", false, () => [useModal]);
